import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@material-ui/core';

import {
  updateOpenDialog,
} from "actions/settings";

import firebase from '../../Firebase';
import 'firebase/database';
import id_default from 'images/sensor_map/id_default.png';


const ImageDialog = (props) => {

  const classes = useStyles();

  const selector_openDialog = useSelector((state) => state.envSettings.openDialog);
  const selector_device_id = useSelector((state) => state.envSettings.selected_device_id);
  const selector_device_label = useSelector((state) => state.envSettings.selected_device_label);

  const [imageUrl, setImageUrl] = useState('');

  const closeDialog = () => {
    props.updateOpenDialog(false);
  }


  const fetchImages = async () => {

    try{
      if(selector_device_id?.length > 0){
        const imageUrl = await firebase.storage()
                          .ref("sensor_map/" + selector_device_id + ".png")
                          .getDownloadURL();
        setImageUrl(imageUrl);
      }
    } catch(error){
      console.log("err: " + error);
      setImageUrl(id_default);
    }

  }


  useEffect(() => {
    // console.log("selector_device_id: ", selector_device_id);
    fetchImages();
  }, [selector_device_id])


  return (

    <div className={classes.root}>

      <Dialog open={selector_openDialog}
        onClose={() => { closeDialog() }}
        fullWidth={true}
        maxWidth="sm"
      >

        <DialogTitle align="center">
          <Typography variant="h5">{selector_device_label}</Typography>
        </DialogTitle>

        <DialogContent>
          <img
            src={imageUrl}
            align="center"
            alt={selector_device_label}
            // alt={imageUrl}
            loading="lazy"
            className={classes.imageViewer}
          />
        </DialogContent>

        <DialogActions style={{ padding: '20px 0px 20px 0px' }}>

          <Grid container item className={classes.action}
            direction="row" alignItems="center" justifyContent="center">

            <Button
              variant="outlined"
              size="large"
              onClick={() => closeDialog()}
              className={classes.action}
            >
              Close
            </Button>
          </Grid>
        </DialogActions>

      </Dialog>
    </div>
  )
}


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateOpenDialog,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    settings: state.settings
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageDialog);



const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(1),
  },

  imageViewer: {
    width: "100%",
    objectFit: "cover",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },

  table: {
    width: "600px",
    minWidth: "400px",
    maxWidth: "800px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#777",
    borderCollapse: "collapse",
    // padding: "10px",
  },
  th: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#777",
    padding: "4px",
    fontSize: 14,
    align: "center",
  },
  tr: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#777",
    padding: "4px",
    fontSize: 14,
  }
}));